import React from 'react';
import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import RatingsSection from '../components/RatingsSection';
import ScreenshotsSection from '../components/ScreenshotsSection';
import FeaturesSection from '../components/FeaturesSection';
import CTASection from '../components/CTASection';

const HomePage = () => {
  const homeSchema = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "GTO Preflop",
    "description": "Master Game Theory Optimal poker strategy with our comprehensive preflop training app",
    "applicationCategory": "GameApplication",
    "operatingSystem": "iOS, Android",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.5",
      "ratingCount": "275"
    }
  };

  return (
    <>
      <SEO 
        description="Master GTO poker strategy with our preflop training app. Features ranges viewer, interactive trainer, and comprehensive poker calculators. Available on iOS and Android."
        keywords="GTO preflop app, poker training app, preflop ranges, poker strategy app"
        schema={homeSchema}
      />
      <main>
        <HeroSection />
        <RatingsSection />
        <ScreenshotsSection />
        <FeaturesSection />
        <CTASection />
      </main>
    </>
  );
};

export default HomePage; 